export const DEFAULT_ROLES = [
  'Time&Attendance:Admin',
  'Time&Attendance:Manager',
  'Time&Attendance:Supervisor',
];

export const DAILY_SNAPSHOT_NAME = 'Daily Snapshot';
